import { render } from "./DocumentsSection.vue?vue&type=template&id=413a6003&scoped=true"
import script from "./DocumentsSection.vue?vue&type=script&lang=js"
export * from "./DocumentsSection.vue?vue&type=script&lang=js"

import "./DocumentsSection.vue?vue&type=style&index=0&id=413a6003&scoped=true&lang=css"

import exportComponent from "../../../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413a6003"]])

export default __exports__